import { parseEntity } from '@/shared/converters/commonConverters';
import { DateTimeFormat, parseMoment } from '@/shared/converters/dateConverters';
import { parseTags } from '@/shared/converters/tagConverters';
import { present } from '@/shared/utils/typescript';
import WorkPreparationSearchResult from '../models/WorkPreparationSearchResult';
import WorkPreparationSearchResultContainer from '../models/WorkPreparationSearchResultContainer';
import { parseWorkPreparationRoles } from './WorkPreparationRoleConverters';
import { parseWorkPreparationItems } from './workPreparationConverters';

const WRAPPER_SCHEMA = {
  roleId: 'workPreparationRoleId',
  roles: (data: any) => parseWorkPreparationRoles(data.workPreparationRoles),
  searchResults: (data: any) => parseWorkPreparationSearchResults(data),
};

const SCHEMA = {
  id: 'id',
  workStatus: 'dossierStatuses.workStatus',
  partsOrderStatus: 'dossierStatuses.partsOrderStatus',
  vehicleStatus: 'dossierStatuses.objectStatus',
  workPreparationStatus: 'workPreparationStatus',
  pickingStatus: 'pickingStatus',
  plannedVisit: (data: any) => parseMoment(data.plannedVisit, DateTimeFormat.LEGACY),
  tags: (data: any) => parseTags(data.tags),
  externalReference: 'externalReference',
  hasPreCheckin: (data: any) => !data.isPreCheckinExcluded,
  waitsOnPremise: 'waitsOnPremise',
};

export function parseWorkPreparationSearchResults(data: any): Array<WorkPreparationSearchResult> {
  return data.dossiers.map((dossier: any) => {
    const result  =  present(parseWorkPreparationSearchResult(dossier));
    result.workPreparations = parseWorkPreparationItems(
      dossier.workPreparations,
      data.workPreparationRoles,
      data.workPreparationRoleId,
    );
    return result;
  });
}

export function parseWorkPreparationSearchResult(data: any): WorkPreparationSearchResult | null {
  return parseEntity(data, SCHEMA, WorkPreparationSearchResult);
}

export function parseWorkPreparationSearchResultContainer(data: any): WorkPreparationSearchResultContainer | null {
  return parseEntity(data, WRAPPER_SCHEMA, WorkPreparationSearchResultContainer);
}